import { render, staticRenderFns } from "./AnimationGrid.vue?vue&type=template&id=3b4957c3&scoped=true&"
import script from "./AnimationGrid.vue?vue&type=script&lang=js&"
export * from "./AnimationGrid.vue?vue&type=script&lang=js&"
import style0 from "./AnimationGrid.vue?vue&type=style&index=0&id=3b4957c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4957c3",
  null
  
)

export default component.exports